import React from 'react';
import _merge from 'lodash/merge';
import { getContext } from 'common';
import styled from './styles';

export interface BreadcrumbIconProps extends React.ComponentPropsWithRef<'div'> {
  /** Children prop is where icon content resides. */
  children: React.ReactNode;
  /** To override the theme please refer to the "Readme" tab to learn more. */
  theme?: any;
}

/**
 * Single BreadcrumbIcon component.
 * Any other props than `children` will be provided to the root element. */
const BreadcrumbIcon = React.forwardRef<HTMLElement, BreadcrumbIconProps>((props: BreadcrumbIconProps, ref) => getContext(({ theme }) => {
  const {
    children,
    theme: themeProp,
    ...otherProps
  } = props;

  const resolvedTheme = _merge({}, theme ? theme.BREADCRUMBS : {}, themeProp);

  return (
    <styled.BreadcrumbIcon ref={ref} $theme={resolvedTheme} {...otherProps}>
      {children}
    </styled.BreadcrumbIcon>
  );
}));

BreadcrumbIcon.displayName = 'BreadcrumbIcon';

BreadcrumbIcon.defaultProps = {
  theme: {},
};

export default BreadcrumbIcon;
